const {h, render, Component} = require('preact');
const SeeAllGrouponsView = require('./see_all_groupons');
const SpinnerView = require('../../views/common/spinner')

class OrdersView extends Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
        <div id="help-wizard" className="help-wizard" style="display: block;">
          <div className="help-wizard-content">
            <div className="row select-order-menu">
              <div className={this.props.page=='listing'?'row order-listing':'row order-listing landing'} data-bhw="web2018_orders_landing">
                <div>
                  <div id="ordersTablewrapper">
                    <table width="100%" className="scrollableTable">
                      <tbody id="ordersTable">
                      {this.props.ordersTable()}
                      </tbody>
                    </table>
                    {this.props.isLoadingInProgress?<SpinnerView/>:null}
                    {!this.props.isLoadingInProgress && <SeeAllGrouponsView length={this.props.length} groupons={this.props.groupons} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
  }

}

module.exports = OrdersView
